var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7763 0.501715C12.0515 0.746328 12.0762 1.16771 11.8316 1.44289L4.72054 9.44291C4.594 9.58525 4.41266 9.66665 4.22223 9.66665C4.03181 9.66665 3.85047 9.58525 3.72396 9.44291L0.168402 5.44291C-0.0762116 5.16771 -0.0514249 4.74631 0.223768 4.50171C0.498955 4.25711 0.920335 4.28191 1.16495 4.55705L4.22223 7.99651L10.8351 0.557081C11.0797 0.281888 11.5011 0.257102 11.7763 0.501715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTic);
export default __webpack_public_path__ + "static/media/tic.de319995591be9205cf71bb503d2aef9.svg";
export { ForwardRef as ReactComponent };